import { Card } from "react-bootstrap";
import CustomButton from "../../components/CustomButton/CustomButton";
import WebService from "../../utility/WebService";
import { useParams, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import HelperService from "../../utility/HelperService";
import { INVOICE_URL } from "../../utility/WebService";
import CloseButton from "react-bootstrap/CloseButton";

export default function EventBookingDetailsPage() {
  const { bookingId } = useParams<{
    bookingId: string;
  }>();
  const navigate = useNavigate();

  const [booking, setBooking] = useState<any>(null);
  const [event, setEvent] = useState<any>(null);
  const [ticketSections, setTicketSections] = useState<any[]>([]);
  const [downloadingKey, setDownloadingKey] = useState<string | null>(null);

  const [showPopup, setShowPopup] = useState(false);

  const [editForm, setEditForm] = useState({
    status: "PENDING",
    transactionId: "",
  });

  useEffect(() => {
    getBookingDetails();
  }, [bookingId]);

  const getBookingDetails = async () => {
    const res: any = await WebService.getAPI({
      action: `events/booking-detail/${bookingId}`,
    });

    const bookingData = res?.data?.booking;
    const eventData = res?.data?.event;

    setBooking(bookingData);
    setEvent(eventData);

    // GROUP ticket + attendees
    const newTickets = bookingData?.tickets?.map((t: any) => ({
      ticketName: t.name,
      ticketDate: HelperService.dateFormatter(t.date),
      unitAmount: t.unitAmount,
      attendees: t.attendees.map((a: any, i: number) => ({
        name: a.name,
        email: a.email,
        phone: a.phone,
        ticketNumber: a.ticketNumber || `${bookingData.orderNo}-${i + 1}`,
      })),
    }));

    setTicketSections(newTickets);
  };
  const downloadAttendeeTicket = async (
    bookingId: string,
    ticketName: string,
    attendeeIndex: number
  ) => {
    const key = `${ticketName}-${attendeeIndex}`;
    setDownloadingKey(key);

    try {
      const res: any = await WebService.getAPI({
        action: `event-registration/ticket/download/${bookingId}/${ticketName}/${attendeeIndex}`,
      });

      if (res?.success && res?.url) {
        window.open(res.url, "_blank"); // open PDF
      }
    } catch (err) {
      console.error("Download ticket error", err);
    } finally {
      setDownloadingKey(null); // stop loader
    }
  };
  const updatePayment = async () => {
    await WebService.postAPI({
      action: `event-registration/update-booking/${booking._id}`,
      body: {
        status: editForm.status,
        transactionId: editForm.transactionId,
      },
    });

    setShowPopup(false);
    getBookingDetails();
  };

  const toNumber = (val: any) => {
    if (!val) return 0;

    if (typeof val === "number") return val;

    if (typeof val === "string") return Number(val);

    if (val?.$numberDecimal) return Number(val.$numberDecimal);

    return 0;
  };

  const formatDateTime = (value: any) => {
    if (!value) return "-";

    const d = new Date(value);

    return d.toLocaleString("en-IN", {
      day: "2-digit",
      month: "short",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    });
  };

  return (
    <div className="events-main">
      <Card className="event-card p-4">

        {/* HEADER */}
        <div className="d-flex justify-content-between align-items-center mb-4">
          {/* LEFT SIDE TITLE */}
          <div className="page-title m-0" style={{ fontSize: 22, fontWeight: 700 }}>
            Booking Details
          </div>

          {/* RIGHT SIDE CLOSE BUTTON */}
          <CloseButton onClick={() => navigate(-1)} />

          {/* {booking && (
            <CustomButton
              label="Download Invoice"
              isLoading={false}
              onClick={() => window.open(`${INVOICE_URL}events/invoice/${booking._id}`, "_blank")}
              style={{ width: 180 }}
            />
          )} */}
        </div>

        {/* EVENT DETAILS */}
        {event && (
          <div className="mb-4 p-4 rounded shadow-sm bg-white border">
            <h5 className="mb-3" style={{ fontWeight: 700 }}>Event Details</h5>

            <div className="row">
              <div className="col-md-4 mb-2">
                <div className="text-muted small">Event Name</div>
                <div className="fw-semibold">{event.title}</div>
              </div>

              <div className="col-md-4 mb-2">
                <div className="text-muted small">Date</div>
                <div className="fw-semibold">
                  {HelperService.dateFormatter(event.start_date)}
                </div>
              </div>

              <div className="col-md-4 mb-2">
                <div className="text-muted small">Location</div>
                <div className="fw-semibold">{event.location}</div>
              </div>
            </div>
          </div>
        )}

        {/* BOOKING DETAILS */}
        {booking && (
          <div className="mb-4 p-4 rounded shadow-sm bg-white border">
            <h5 className="mb-3" style={{ fontWeight: 700 }}>Booking Details</h5>

            <div className="row">
              <div className="col-md-2 mb-2">
                <div className="text-muted small">Booking Id</div>
                <div className="fw-semibold">{booking.orderNo}</div>
              </div>

              <div className="col-md-2 mb-2">
                <div className="text-muted small">Order ID</div>
                <div className="fw-semibold">{booking.payment.gatewayId}</div>
              </div>

              <div className="col-md-2 mb-2">
                <div className="text-muted small">Transaction Date & Time</div>
                <div className="fw-semibold">
                  {booking?.payment?.status === "PAID"
                    ? formatDateTime(booking?.transactionId?.updatedAt)
                    : "-"}
                </div>
              </div>

              <div className="col-md-2 mb-2">
                <div className="text-muted small">Total Amount</div>
                <div className="fw-bold">₹{toNumber(booking.totalAmount)} INR</div>
              </div>

              <div className="col-md-2 mb-2">
                <div className="text-muted small">Payment Status</div>

                <div className="d-flex align-items-center mt-1">

                  <span
                    style={{
                      padding: "6px 14px",
                      background: booking.payment?.status === "PAID" ? "#d4edda"
                        : booking.payment?.status === "PENDING" ? "#fff3cd"
                          : "#f8d7da",
                      color: booking.payment?.status === "PAID" ? "#155724"
                        : booking.payment?.status === "PENDING" ? "#856404"
                          : "#721c24",
                      borderRadius: "20px",
                      fontWeight: 600,
                    }}
                  >
                    {booking.payment?.status}
                  </span>

                  {booking.payment?.status === "PENDING" && (
                    <button
                      className="btn btn-outline-primary ms-3"
                      style={{ padding: "4px 12px", fontSize: 13 }}
                      onClick={() => setShowPopup(true)}
                    >
                      Edit
                    </button>
                  )}
                </div>
              </div>
            </div>
          </div>
        )}

        {booking && (
          <>
            {/* BILLING DETAILS */}
            <div className="mb-4 p-4 rounded shadow-sm bg-white border">
              <h5 className="mb-3" style={{ fontWeight: 700 }}>
                Billing Details
              </h5>

              <div className="row">
                {/* LEFT SIDE */}
                <div className="col-md-6">
                  <div className="mb-3">
                    <small className="text-muted">Payment Method</small>
                    <div className="fw-semibold">
                      {booking?.paymentMethod || "-"}
                    </div>
                  </div>

                  <div className="mb-3">
                    <small className="text-muted">Billing Name</small>
                    <div className="fw-semibold">
                      {booking?.billing?.address?.name || "-"}
                    </div>
                  </div>

                  <div className="mb-3">
                    <small className="text-muted">Email</small>
                    <div className="fw-semibold">
                      {booking?.billing?.address?.email || "-"}
                    </div>
                  </div>

                  <div className="mb-3">
                    <small className="text-muted">Phone</small>
                    <div className="fw-semibold">
                      {booking?.billing?.address?.phone || "-"}
                    </div>
                  </div>

                  <div className="mb-3">
                    <small className="text-muted">Address</small>
                    <div className="fw-semibold">
                      {booking?.billing?.address?.addressLine || "-"}
                    </div>
                  </div>
                </div>

                {/* RIGHT SIDE */}
                <div className="col-md-6">
                  <div className="row">
                    <div className="col-md-6 mb-3">
                      <small className="text-muted">City</small>
                      <div className="fw-semibold">
                        {booking?.billing?.address?.city?.name || "-"}
                      </div>
                    </div>

                    <div className="col-md-6 mb-3">
                      <small className="text-muted">State</small>
                      <div className="fw-semibold">
                        {booking?.billing?.address?.state?.name || "-"}
                      </div>
                    </div>

                    <div className="col-md-6 mb-3">
                      <small className="text-muted">Country</small>
                      <div className="fw-semibold">
                        {booking?.billing?.address?.country?.name || "-"}
                      </div>
                    </div>

                    <div className="col-md-6 mb-3">
                      <small className="text-muted">Zip Code</small>
                      <div className="fw-semibold">
                        {booking?.billing?.address?.zip || "-"}
                      </div>
                    </div>
                  </div>

                  <div className="mb-3">
                    <small className="text-muted">Company Name</small>
                    <div className="fw-semibold">
                      {booking?.billing?._doc?.companyName || "-"}
                    </div>
                  </div>

                  <div className="mb-3">
                    <small className="text-muted">GST Number</small>
                    <div className="fw-semibold">
                      {booking?.billing?._doc?.gstNumber || "-"}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* PAYMENT SUMMARY (SEPARATE SECTION) */}
            <div className="mb-4 p-4 rounded shadow-sm bg-white border">
              <h5 className="mb-3 fw-bold">Payment Summary</h5>

              <div className="d-flex justify-content-between mb-2">
                <span>Total Ticket Price</span>
                <span>₹{toNumber(booking.transactionId?.subTotal)}</span>
              </div>

              <div className="d-flex justify-content-between mb-2">
                <span>Coupon Code</span>
                <span>{booking.coupon?.code || "-"}</span>
              </div>

              <div className="d-flex justify-content-between mb-2">
                <span>Discount</span>
                <span>- ₹{toNumber(booking.discountedAmount)}</span>
              </div>

              <div className="d-flex justify-content-between mb-2">
                <span>
                  Tax ({booking.taxName} {booking.taxPercentage}%)
                </span>
                <span>₹{toNumber(booking.taxAmount)}</span>
              </div>

              <hr />

              <div className="d-flex justify-content-between fw-bold fs-6">
                <span>Total Paid Amount</span>
                <span>
                  ₹{toNumber(booking.totalAmount)} {booking.currency}
                </span>
              </div>
            </div>
          </>
        )}


        {/* TICKETS & ATTENDEES */}
        <div className="p-4 rounded shadow-sm bg-white border">
          <h5 className="mb-4" style={{ fontWeight: 700 }}>Tickets & Attendees</h5>

          {ticketSections.map((ticket, idx) => (
            <div key={idx} className="mb-4 p-4 rounded border shadow-sm bg-light">

              {/* TICKET HEADER */}
              <div
                className="mb-3 d-flex justify-content-between align-items-center"
              >
                {/* <div>
                  <h6 className="mb-1" style={{ fontWeight: 700 }}>
                    {ticket.ticketName}
                    <span className="text-muted ms-2">₹{ticket.unitAmount}</span>
                  </h6>

                  <div className="text-muted">
                    <strong>Date:</strong> {ticket.ticketDate}
                  </div>
                </div> */}
              </div>

              {/* ATTENDEE CARDS */}
              <div className="row">
                {ticket.attendees.map((att: any, i: number) => (
                  <div key={i} className="col-md-4 mb-3">
                    <div
                      className="p-3 rounded bg-white border shadow-sm d-flex flex-column justify-content-between"
                      style={{ fontSize: 14, height: "100%" }}
                    >
                      <div>
                        <div className="fw-bold mb-2">Attendee {i + 1}</div>

                        <div><strong>Name:</strong> {att.name}</div>
                        <div><strong>Email:</strong> {att.email || "-"}</div>
                        <div><strong>Phone:</strong> {att.phone || "-"}</div>
                        <div><strong>Ticket No:</strong> {att.ticketNumber}</div>
                        <div><strong>Ticket Type:</strong> {ticket.ticketName}</div>
                      </div>

                      {booking.payment?.status === "PAID" && (
                        <CustomButton
                          label={
                            downloadingKey === `${ticket.ticketName}-${i}`
                              ? "Downloading..."
                              : "Download Ticket"
                          }
                          isLoading={downloadingKey === `${ticket.ticketName}-${i}`}
                          onClick={() =>
                            downloadAttendeeTicket(booking._id, ticket.ticketName, i)
                          }
                          style={{ width: "100%", marginTop: 12 }}
                        />
                      )}
                    </div>
                  </div>
                ))}
              </div>

            </div>
          ))}
        </div>

      </Card>

      {/* ==== POPUP ==== */}
      {showPopup && (
        <div className="modal-backdrop" style={backDropStyle}>
          <div className="modal-box" style={modalBoxStyle}>
            <h4>Edit Payment</h4>

            <label>Status</label>
            <select
              className="form-control mb-3"
              value={editForm.status}
              onChange={(e) => setEditForm({ ...editForm, status: e.target.value })}
            >
              <option value="PENDING">Pending</option>
              <option value="PAID">Paid</option>
            </select>

            <label>Order ID</label>
            <input
              className="form-control"
              value={editForm.transactionId}
              onChange={(e) => setEditForm({ ...editForm, transactionId: e.target.value })}
            />

            <div className="d-flex justify-content-end mt-4 gap-2">
              <CustomButton isLoading={false} label="Cancel" onClick={() => setShowPopup(false)} />
              <CustomButton isLoading={false} label="Save" onClick={updatePayment} />
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

const backDropStyle: any = {
  position: "fixed",
  inset: 0,
  background: "rgba(0,0,0,.5)",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  zIndex: 9999
};

const modalBoxStyle: any = {
  width: 400,
  background: "#fff",
  padding: 20,
  borderRadius: 8
};
